import { request } from '@umijs/max';

/** 导航路径列表 GET /robot/navigation/list */
export function getNavigationList(
  data: API.PageParams & API.NAVIGATION.NavigationSearch = {
    pageNum: 1,
    pageSize: 12,
  },
) {
  return request<API.ListResponse<API.NAVIGATION.Navigation>>(
    '/robot/navigation/list',
    {
      method: 'GET',
      params: data,
    },
  );
}

/** 新增导航路径 POST /robot/navigation/add */
export function createNavigation(data: Omit<API.NAVIGATION.Navigation, 'id'>) {
  return request<API.BaseResponse>('/robot/navigation/add', {
    method: 'POST',
    data,
  });
}

/** 获取导航路径详情 GET /robot/navigation/getById */
export function getNavigationDetail(id: string) {
  return request<API.CommonResponse<API.NAVIGATION.Navigation>>(
    `/robot/navigation/${id}`,
    {
      method: 'GET',
    },
  );
}

/** 获取地图数据 GET /robot/map/getByMapId */
export function getMapData(payload: { mapId: string } | { mapFile: string }) {
  if ('mapFile' in payload) {
    const { mapFile } = payload;
    return Promise.resolve({
      yaml: `${mapFile}occ_grid.yaml`,
      pgm: `${mapFile}occ_grid.pgm`,
      pcd: `${mapFile}full_cloud.pcd`,
    });
  } else {
    return request<API.CommonResponse<API.NAVIGATION.MapFile>>(
      '/robot/map/getByMapId',
      {
        method: 'GET',
        params: payload,
      },
    ).then((res) => {
      if (res.code === 200 && res.data) {
        return {
          yaml: `${res.data}occ_grid.yaml`,
          pgm: `${res.data}occ_grid.pgm`,
          pcd: `${res.data}full_cloud.pcd`,
        };
      }
      return {
        yaml: '',
        pgm: '',
        pcd: '',
      };
    });
  }
}
export function getMapJSONData(mapId: string) {
  return request<API.CommonResponse<API.NAVIGATION.MapFile>>(
    '/robot/map/getByMapId',
    {
      method: 'GET',
      params: { mapId },
    },
  ).then((res) => {
    if (res.code === 200 && res.data) {
      const mapFile = res.data;
      return request(mapFile)
        .then((res) => ({
          code: 200,
          msg: '',
          data: res,
        }))
        .catch((err) => ({
          code: 500,
          msg: '获取地图数据失败',
        }));
    }
    return res;
  });
}
export function getMockMapData(mapId: string) {
  return request('/mock/maps/gridmap', {
    method: 'GET',
    params: { mapId },
  });
}
